export const getGroupStorageKey = (env, type) => `show_group_${env}_${type}`;

export const getStoredGroupExpanded = (storage, env, type) => {
    const scopedKey = getGroupStorageKey(env, type);
    const scopedValue = storage.getItem(scopedKey);
    if (scopedValue != null) return scopedValue !== 'false';

    const expanded = storage.getItem("show_group_" + type) !== 'false';
    storage.setItem(scopedKey, expanded);
    return expanded;
};

export const mergeExpandedGroups = (groups, current, getDefault) => {
    let changed = Object.keys(current).length !== groups.length;
    const next = groups.reduce((result, group) => {
        const expanded = current[group.type] ?? getDefault(group.type);
        result[group.type] = expanded;
        if (current[group.type] !== expanded) changed = true;
        return result;
    }, {});

    return changed ? next : current;
};
